<template lang="pug">
.cursos
  .titulo
    span 📚 Mis cursos
  .contenedor-scroll
    .curso(
      v-for="curso in lista"
      :key="curso.id"
    )
      .cabecera
        .nombre
          strong {{curso.titulo}}
        .porcentaje
          strong {{curso.progreso}}%
      .barra
        .avance(
          :style="{width: curso.progreso+'%'}"
        )
      .detalle
        span
          i.fa.fa-book
          |  {{curso.NumeroClases}} Clases
        span(
          :class="estadoClass(curso.progreso)"
        )
          | {{estado(curso.progreso)}}
      .detalle.margin-top-6
        span
          i.fa.fa-clock-o
          |  Duracion
        span
          | {{curso.DuracionTotal}}
      button.btn-continuar(
        @click="continuar(curso.id)"
      )
        i.fa.fa-play
        | Continuar
</template>
<script>
import { apiGet, notify }  from '../../util/general'
import moment from 'moment';
export default {
  name:'KpiCursos',
  props: {
    cursos: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      lista                                 : [],
      mes                                   : moment().month() + 1,
      isLoading                             : false,
      disabledScrollExecute                 : false,
      noMore                                : false,
      isScroll                              : false,
      skip                                  : 0
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm                    = this
      vm.isLoading              = true
      vm.disabledScrollExecute  = true
      vm.noMore                 = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }

      var obj = {}

      apiGet(vm, '/curso/virtual/alumno/lista', obj, function (data) {
        console.log('data.lista cursos >>>>>>', data.lista)
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isScroll  = false
        vm.isLoading = false
      })
    },
    estado (avance) {
      if (avance === 100) {
        return 'Completado'
      }
      if (avance >= 50) {
        return 'En progreso'
      }

      return 'Pendiente'
    },
    estadoClass (avance) {
      if (avance === 100) {
        return 'verde'
      }
      if (avance >= 50) {
        return 'amarillo'
      }
      return 'rojo'
    },
    continuar (id) {
      var vm                    = this
      vm.$router.push('/mis-cursos/' + id + '/clases')
    }
  }
}
</script>
<style lang="stylus" scoped>
.contenedor-scroll
  flex 1
  overflow-y auto
  padding-right 6px
  &::-webkit-scrollbar
    width 6px
  &::-webkit-scrollbar-thumb
    background #bdbdbd
    border-radius 10px
  &::-webkit-scrollbar-track
    background transparent
.cursos
  background white
  border-radius 10px
  padding 20px
  width 420px
  height 420px
  display flex
  flex-direction column
  box-shadow 0 2px 8px rgba(0,0,0,.08)
.titulo
  font-size 16px
  font-weight bold
  margin-bottom 20px
.curso
  padding 15px
  margin-bottom 15px
  border 1px solid #eee
  border-radius 10px
.cabecera
  display flex
  justify-content space-between
.nombre
  font-size 14px
.porcentaje
  color #536dfe
.barra
  height 8px
  background #eee
  border-radius 10px
  margin 10px 0
.avance
  height 100%
  background #536dfe
  border-radius 10px
.detalle
  display flex
  justify-content space-between
  font-size 12px
  color #777
.verde
  color green
.amarillo
  color orange
.rojo
  color red
.btn-continuar
  margin-top 12px
  width 100%
  border none
  background #536dfe
  color white
  padding 8px
  border-radius 5px
  cursor pointer
.margin-top-6
  margin-top: 6px;
</style>



// WEBPACK FOOTER //
// c_kpi_cursos.vue?773ed8f6